/** Joins class names, skipping falsy ones. */
export function cn(...classes: readonly (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}

/**
 * The focus ring: 2px of `primary-main`, outside the control, as the mockups have it. It reaches
 * 3:1 on every background in both schemes, as WCAG 2.2 AA asks of a focus indicator
 * (`focus-ring-contrast.test.ts`).
 */
export const focusRing =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-main'

/**
 * A link in text or a table cell: the design system's Link, `primary-main` and always underlined.
 * The underline keeps it from depending on color alone (WCAG 1.4.1); in the dark scheme the green
 * is only 2:1 against body text.
 */
export const inlineLink = `rounded-xs text-primary-main underline ${focusRing}`

/**
 * A link or small button that stands alone rather than in a sentence, such as a link in a table
 * cell or a chooser's Choose: at least 24 by 24 px, as WCAG 2.2 asks of a target (2.5.8). A long
 * unbroken label, such as an email address, still wraps to fit.
 */
export const targetSize = 'inline-flex min-h-6 min-w-6 max-w-full items-center justify-center wrap-anywhere'

/** The same ring drawn inside the control, where a scrolling container would clip one outside. */
export const insetFocusRing =
  'focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary-main'
